// Safari (16.4+) only: switch the browser’s OS-level audio session to "play-and-record"
// so getUserMedia() can run while audio is playing (e.g., metronome) — prevents the
// “AudioSession category is not compatible with audio capture” error. No-op elsewhere.
export function ensureSafariAudioSession() {
  const anyNav = navigator as any;
  if (anyNav.audioSession && typeof anyNav.audioSession.type === 'string') {
    try {
      anyNav.audioSession.type = 'play-and-record';
    } catch (e) {
      // Non-fatal: older Safari or type locked by UA
      console.warn('Could not switch audio session:', e);
    }
  }
}
